export const FOREGROUND = 'foreground';
export const BACKGROUND = 'background';
